import Field from '..'
import cn from 'classnames'
import { useState } from 'react'
import styles from './index.module.scss'
import { useEffect } from 'react'

export default function FieldInput({ name, index, defaultValue, fieldKey, field }) {

    const {
        className,
        required
    } = field

    const [selected, setSelected] = useState(false)
    const [value, setValue] = useState(defaultValue || "")

    useEffect(() => {
        if ( defaultValue ) setValue(defaultValue)
    }, [defaultValue])
    
    const onFocus = () => setSelected(true)
    const onBlur = () => setSelected(false)
    const onChange = (val) => setValue(val)

    return (
        <Field field={field} className={cn(styles.field, ((selected || value) && styles.selected), (field.type === 'email' && styles.email))}>
            <label className={styles.label}>{field.label}</label>
            <input 
                type="text" 
                name={name}
                value={value}
                className={cn(className, styles.input)} 
                required={required} 
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={(e) => onChange(e.target.value)}
            />
        </Field>
    )

}